import 'css-chunk:src/app/containers/Projects/AutomationPage/templateModal/TemplateModal.scss';export default {
  "TemplateModal": "_TemplateModal_14o1q_1",
  "templateList": "_templateList_14o1q_1"
};